import { render, staticRenderFns } from "./startup.vue?vue&type=template&id=65344058&scoped=true"
import script from "./startup.vue?vue&type=script&lang=js"
export * from "./startup.vue?vue&type=script&lang=js"
import style0 from "./startup.vue?vue&type=style&index=0&id=65344058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65344058",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextPressure: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/text-pressure.vue').default,AuroraBackground: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/aurora-background.vue').default,BtnReadmore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-readmore.vue').default,PageBottom: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-bottom/index.vue').default})
